import { gql } from '@apollo/client'

export const GET_MY_HOLE_IN_ONE = gql`
  query MyHoleInOne($id: ID!) {
    myHoleInOne(id: $id) {
      id
      slug
      golferName
      golferHometown
      courseName
      occurredAt
      holeNumber
      holePar
      yardage
      age
      gender
      handicap
      yearsPlaying
      totalHios
      clubType
      clubBrand
      clubModel
      ballBrand
      ballModel
      witnesses
      description
      photoUrls
      videoUrls
      featuredPhotoUrl
      displayOptIn
      displayNameFormat
      publicVisibility
      status
      publishedAt
      pgaProfessional
    }
  }
`

export const UPDATE_MY_HOLE_IN_ONE = gql`
  mutation UpdateMyHoleInOne($input: UpdateMyHoleInOneInput!) {
    updateMyHoleInOne(input: $input) {
      id
      golferName
      golferHometown
      gender
      age
      handicap
      yearsPlaying
      totalHios
      clubType
      clubBrand
      clubModel
      ballBrand
      ballModel
      witnesses
      description
      photoUrls
      videoUrls
      featuredPhotoUrl
      displayOptIn
      displayNameFormat
      publicVisibility
      status
      publishedAt
    }
  }
`

export const PUBLISH_MY_HOLE_IN_ONE = gql`
  mutation PublishMyHoleInOne($id: ID!) {
    publishMyHoleInOne(id: $id) {
      holeInOne {
        id
        status
        publishedAt
      }
    }
  }
`

export const DELETE_MY_HOLE_IN_ONE = gql`
  mutation DeleteMyHoleInOne($id: ID!) {
    deleteMyHoleInOne(id: $id) {
      success
      message
      code
    }
  }
`
